import LibraryElementEnum from 'client/enums/LibraryElementEnum'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { libraryItems } from 'src/editor/layout/sidebar/library/library-items'
import { WebsiteHeaderElementIcon } from './website-header-element-icon'

interface WebsiteHeaderLibraryElementProps {
  libraryElement: LibraryElementEnum
}

export const WebsiteHeaderLibraryElement = ({
  libraryElement,
}: WebsiteHeaderLibraryElementProps) => {
  const { t } = useTranslation()
  const item = libraryItems[libraryElement]
  return (
    <span className="flex items-center gap-2">
      <WebsiteHeaderElementIcon>
        {'className' in item && <span className={item.className} />}
        {'iconRenderer' in item && item.iconRenderer?.()}
      </WebsiteHeaderElementIcon>
      {t(item?.title)}
    </span>
  )
}
